(() => {
  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const rafThrottle = (callback) => {
    let ticking = false;
    return () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        callback();
      });
    };
  };

  onReady(() => {
    const categoryGroups = [
      { label: 'OUTERWEAR', displayLabel: 'Outerwear', values: ['Coats', 'Coats and jackets', 'Body mists', 'Outerwear', 'Jacket', 'Giacca', 'Capospalla', 'Cappotti', 'Cappotti e giacche', 'Nebbie per corpo'] },
      { label: 'KNITWEAR', displayLabel: 'Knitwear', values: ['Sweaters', 'Cardigans', 'Body mists', 'Knitwear', 'Maglieria', 'Maglioni', 'Cardigan', 'Nebbie per corpo'] },
      { label: 'HOODIES', displayLabel: 'Hoodies', values: ['Hoodies', 'Hoodie', 'Felpe con cappuccio', 'Felpa con cappuccio'] },
      { label: 'SHIRT', displayLabel: 'Shirt', values: ['Shirt', 'Camicia'] },
      { label: 'TEES', displayLabel: 'Tees', values: ['Tees', 'T-shirts', 'T-shirt', 'Maglietta', 'Magliette'] },
      { label: 'DENIM', displayLabel: 'Denim', values: ['Jeans', 'Denim'] },
      { label: 'BOTTOMS', displayLabel: 'Bottoms', values: ['Bottoms', 'Pantaloni'] },
      { label: 'UNDERWEAR', displayLabel: 'Underwear', values: ['Boxer shorts', 'Briefs', 'Socks', 'Tank tops', 'Underwear', 'Boxer larghi', 'Boxer slip', 'Calzini', 'Canotte', 'Intimo', 'Top'] },
      { label: 'HEADWEAR', displayLabel: 'Headwear', values: ['Beanies', 'Baseball caps', 'Beanie', 'Hat', 'Berretto', 'Berretti', 'Cappello', 'Cappellini da baseball'] },
      { label: 'ACCESSORIES', displayLabel: 'Accessories', values: ['Keychains', 'Ashtrays', 'Pins', 'Accessories', 'Portachiavi', 'Posacenere', 'Spille e spillette', 'Accessori', 'Belt', 'Cintura'] },
      { label: 'BAGS', displayLabel: 'Bags', values: ['Shoulder bags', 'Bag', 'Borsa', 'Borse a spalla'] },
      { label: 'EYEWEAR', displayLabel: 'Eyewear', values: ['Sunglasses', 'Eyewear', 'Occhiali', 'Occhiali da sole'] }
    ];

    const normalizeCategoryValue = (value) => decodeURIComponent(String(value || '')).trim().toLowerCase();
    const getCategoryGroupByValue = (value) => {
      const normalized = normalizeCategoryValue(value);
      return categoryGroups.find((group) =>
        group.values.some((member) => normalizeCategoryValue(member) === normalized)
      ) || null;
    };

    const headerSection = document.getElementById('shopify-section-header');
    const headerWrapper = headerSection?.querySelector('.header-wrapper');
    const gridRoot = document.querySelector('[data-collection-grid-root]');
    const refineDrawer = document.querySelector('[data-collection-refine]');
    const refineViewOptionDetails = document.querySelector('[data-refine-view-option-details]');
    const filterDisclosure = document.querySelector('.mobile-facets__disclosure');
    const filterSummary = filterDisclosure?.querySelector('summary');
    const mobileMq = window.matchMedia('(max-width: 989px)');
    let categoryManuallyClosed = false;
    let currentGridView = mobileMq.matches ? '2' : '4';
    const getText = (element) => (element?.textContent || '').replace(/\s+/g, ' ').trim();
    const isCategoryDetails = (element) =>
      element?.matches?.(".mobile-facets__details[data-filter-label='tipo-di-prodotto'], .mobile-facets__details[data-filter-label='categoria'], .mobile-facets__details[data-filter-label='category']");

    const ensureCategoryDetailsOpen = (root = document) => {
      if (categoryManuallyClosed) return;
      const form = root.querySelector?.('#FacetFiltersFormMobile') || document.getElementById('FacetFiltersFormMobile');
      const categoryDetails = form?.querySelector?.(".mobile-facets__details[data-filter-label='tipo-di-prodotto'], .mobile-facets__details[data-filter-label='categoria'], .mobile-facets__details[data-filter-label='category']");
      if (categoryDetails && !categoryDetails.hasAttribute('open')) {
        categoryDetails.setAttribute('open', '');
      }
    };

    const syncMobileFilterBreadcrumb = (root = document, preferredDetails = null) => {
      const form = root.querySelector?.('#FacetFiltersFormMobile') || document.getElementById('FacetFiltersFormMobile');
      if (!form) return;

      const currentElements = Array.from(document.querySelectorAll('[data-mobile-facets-trigger-current]'));
      if (!currentElements.length) return;
      const openLabels = currentElements
        .map((current) => current.closest('.mobile-facets__open-label'))
        .filter(Boolean);
      const defaultLabel = (form.dataset.mobileTriggerDefaultLabel || '').trim();

      const openDetails = preferredDetails?.matches?.('.mobile-facets__details[open]')
        ? preferredDetails
        : form.querySelector('.mobile-facets__details[open]');
      const openCheckedLabels = openDetails
        ? Array.from(openDetails.querySelectorAll('.mobile-facets__checkbox:checked'))
            .map((input) => getText(input.closest('.mobile-facets__label')?.querySelector('.mobile-facets__label-text')))
            .filter(Boolean)
        : [];

      const allCheckedLabels = Array.from(form.querySelectorAll('.mobile-facets__checkbox:checked'))
        .map((input) => getText(input.closest('.mobile-facets__label')?.querySelector('.mobile-facets__label-text')))
        .filter(Boolean);

      let nextText = '';
      if (defaultLabel) {
        nextText = defaultLabel;
      } else if (openCheckedLabels.length) {
        nextText = openCheckedLabels.join(', ');
      } else if (allCheckedLabels.length) {
        nextText = allCheckedLabels.join(', ');
      }

      
      if (nextText.toLowerCase() === 'filter') {
        nextText = '';
      }

      currentElements.forEach((current) => {
        current.textContent = nextText;
      });

      openLabels.forEach((label) => {
        label.classList.toggle('has-current', Boolean(nextText));
      });
    };

    const normalizeView = (view) => {
      const raw = String(view || '');
      if (mobileMq.matches) {
        return ['4', '2', '1'].includes(raw) ? raw : '2';
      }
      return ['8', '4', '2'].includes(raw) ? raw : '4';
    };

    const getCardSizes = (view) => {
      if (mobileMq.matches) {
        if (view === '1') return '100vw';
        if (view === '4') return '25vw';
        return '50vw';
      }

      if (view === '8') return '12.5vw';
      if (view === '2') return '30vw';
      return '25vw';
    };

    const syncNextCategoryLinks = (root = document) => {
      root.querySelectorAll?.('[data-next-category-link]')?.forEach((link) => {
        const paramName = (link.dataset.paramName || '').trim();
        const currentValue = (link.dataset.currentValue || '').trim();
        const nextValue = (link.dataset.nextValue || '').trim();
        if (!paramName || !nextValue) return;

        const params = new URLSearchParams(window.location.search);
        const currentValues = params.getAll(paramName);

        const looksLikeCategoryParam = currentValues.some((value) => getCategoryGroupByValue(value)) || getCategoryGroupByValue(currentValue);
        if (looksLikeCategoryParam) {
          const currentGroup =
            currentValues.map(getCategoryGroupByValue).find(Boolean) ||
            getCategoryGroupByValue(currentValue);

          if (!currentGroup) return;

          const currentIndex = categoryGroups.findIndex((group) => group.label === currentGroup.label);
          const nextGroup = categoryGroups[(currentIndex + 1) % categoryGroups.length];
          if (!nextGroup) return;

          params.delete(paramName);
          params.delete('page');
          nextGroup.values.forEach((value) => params.append(paramName, value));

          const labelTarget = link.querySelector('span');
          if (labelTarget) labelTarget.textContent = nextGroup.displayLabel || nextGroup.label;

          const query = params.toString();
          link.href = `${window.location.pathname}${query ? `?${query}` : ''}`;
          return;
        }

        params.delete(paramName);
        if (currentValue && currentValue !== nextValue) {
          params.delete('page');
        }
        params.append(paramName, nextValue);

        const query = params.toString();
        link.href = `${window.location.pathname}${query ? `?${query}` : ''}`;
      });
    };

    const applyGridView = (view, options = {}) => {
      if (!gridRoot) return;
      const nextView = normalizeView(view);
      currentGridView = nextView;
      gridRoot.dataset.gridViewState = nextView;
      if (options.userSelected) {
        gridRoot.dataset.gridUserSelected = 'true';
      }
      gridRoot.classList.remove(
        'collection-grid-545--view-8',
        'collection-grid-545--view-4',
        'collection-grid-545--view-2',
        'collection-grid-545--view-1'
      );
      gridRoot.classList.add(`collection-grid-545--view-${nextView}`);
      gridRoot.classList.add('collection-grid-545--ready');
      document.querySelectorAll('[data-grid-view]').forEach((button) => {
        const isMobileOnly = button.classList.contains('collection-refine-545__option--mobile');
        const isDesktopOnly = button.classList.contains('collection-refine-545__option--desktop');
        const visibleInCurrentViewport = mobileMq.matches ? !isDesktopOnly : !isMobileOnly;
        const isActive = visibleInCurrentViewport && button.dataset.gridView === nextView;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      const activeViewButton = Array.from(document.querySelectorAll('[data-grid-view].is-active')).find((button) => {
        const isMobileOnly = button.classList.contains('collection-refine-545__option--mobile');
        const isDesktopOnly = button.classList.contains('collection-refine-545__option--desktop');
        return mobileMq.matches ? !isDesktopOnly : !isMobileOnly;
      });

      document.querySelectorAll('[data-refine-view-current]').forEach((target) => {
        target.innerHTML = activeViewButton?.querySelector('.collection-refine-545__option-icon')?.innerHTML || '';
      });

      const sizes = getCardSizes(nextView);
      gridRoot.querySelectorAll('.card-545__img, .card-545__cover-img').forEach((image) => {
        image.setAttribute('sizes', sizes);
      });
    };


    const applyNativeRefineFilters = () => {
      const inputs = Array.from(document.querySelectorAll('[data-refine-native-input]'));
      if (!inputs.length) return;

      const params = new URLSearchParams(window.location.search);
      const paramNames = [...new Set(inputs.map((input) => input.name).filter(Boolean))];
      paramNames.forEach((name) => params.delete(name));

      inputs.forEach((input) => {
        if (input.checked && input.name) {
          params.append(input.name, input.value);
        }
      });

      const searchParams = params.toString();
      if (typeof FacetFiltersForm !== 'undefined' && typeof FacetFiltersForm.renderPage === 'function') {
        FacetFiltersForm.renderPage(searchParams, null);
      } else {
        window.location.search = searchParams;
      }
    };

    const syncCategoryGroupInputs = (changedInput) => {
      const container =
        changedInput.closest('.mobile-facets__details, .facets__display, .facets__disclosure, .mobile-facets__submenu') ||
        changedInput.closest('form');
      if (!container) return;

      container.querySelectorAll('[data-category-group-hidden]').forEach((input) => {
        input.checked = false;
      });

      container.querySelectorAll('[data-category-group-input]').forEach((input) => {
        if (input !== changedInput) input.checked = false;
      });

      if (!changedInput.checked) return;

      const groupKey = changedInput.dataset.categoryGroupKey || '';
      container.querySelectorAll(`[data-category-group-hidden][data-category-group-key="${groupKey}"]`).forEach((input) => {
        input.checked = true;
      });
    };

    document.querySelectorAll('[data-refine-native-input]').forEach((input) => {
      input.addEventListener('input', (event) => {
        event.stopPropagation();
      });
      input.addEventListener('change', (event) => {
        if (!event.target.checked) return;
        document.querySelectorAll('[data-refine-native-input]').forEach((otherInput) => {
          if (otherInput === event.target) return;
          otherInput.checked = false;
        });
      });
      input.addEventListener('change', applyNativeRefineFilters);
    });

    const openRefine = ({ openViewOption = false } = {}) => {
      if (!refineDrawer) return;
      closeFilter();
      refineDrawer.hidden = false;
      if (openViewOption && refineViewOptionDetails && !refineViewOptionDetails.hasAttribute('open')) {
        refineViewOptionDetails.setAttribute('open', '');
      }
      document.documentElement.classList.add('kowi-lock');
      document.body.classList.add('kowi-lock');
      document.body.classList.add('collection-refine-open');
    };

    const closeRefine = () => {
      if (!refineDrawer) return;
      refineDrawer.hidden = true;
      document.documentElement.classList.remove('kowi-lock');
      document.body.classList.remove('kowi-lock');
      document.body.classList.remove('collection-refine-open');
    };

    const openFilter = () => {
      if (!filterDisclosure || !filterSummary) return;
      closeRefine();
      if (!filterDisclosure.hasAttribute('open')) {
        filterSummary.click();
      }
    };

    const closeFilter = () => {
      if (!filterDisclosure || !filterSummary) return;
      if (filterDisclosure.hasAttribute('open')) {
        filterSummary.click();
      }
    };

    document.querySelectorAll('[data-collection-refine-open]').forEach((button) => {
      button.addEventListener('click', openRefine);
    });

    document.querySelectorAll('[data-collection-refine-open-view-option]').forEach((button) => {
      button.addEventListener('click', () => openRefine({ openViewOption: true }));
    });

    document.querySelectorAll('[data-collection-refine-close]').forEach((button) => {
      button.addEventListener('click', closeRefine);
    });

    if (filterSummary) {
      filterSummary.addEventListener('click', () => {
        if (!filterDisclosure?.hasAttribute('open')) {
          closeRefine();
        }
      });
    }

    document.addEventListener('click', (event) => {
      const button = event.target.closest?.('[data-grid-view]');
      if (!button) return;
      event.preventDefault();
      applyGridView(button.dataset.gridView, { userSelected: true });
      closeRefine();
    });

    document.addEventListener('click', (event) => {
      const shopAllLink = event.target.closest?.('[data-shop-all-trigger-link]');
      if (!shopAllLink) return;
      event.stopPropagation();
    }, true);

    document.addEventListener('toggle', (event) => {
      if (!event.target.matches?.('.mobile-facets__details')) return;
      if (isCategoryDetails(event.target)) {
        categoryManuallyClosed = !event.target.hasAttribute('open');
      }
      syncMobileFilterBreadcrumb(document, event.target);
    }, true);

    document.addEventListener('change', (event) => {
      if (event.target.matches?.('[data-category-group-input]')) {
        syncCategoryGroupInputs(event.target);
      }

      const mobileFiltersForm = event.target.closest?.('#FacetFiltersFormMobile');
      if (!mobileFiltersForm) return;

      if (event.target.matches?.('.mobile-facets__checkbox')) {
        if (event.target.checked) {
          mobileFiltersForm.querySelectorAll('.mobile-facets__checkbox').forEach((otherInput) => {
            if (otherInput === event.target) return;
            otherInput.checked = false;
          });
        }
        const details = event.target.closest('.mobile-facets__details');
        syncMobileFilterBreadcrumb(document, details);
        window.setTimeout(syncMobileFilterBreadcrumb, 650);
      }

      if (event.target.matches?.('input, select')) {
        window.setTimeout(() => {
          closeFilter();
          syncMobileFilterBreadcrumb(document);
          window.setTimeout(() => {
            syncMobileFilterBreadcrumb(document);
          }, 120);
        }, 550);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeRefine();
    });

    document.addEventListener('facets:rendered', () => {
      window.setTimeout(() => {
        applyGridView(currentGridView);
        ensureCategoryDetailsOpen(document);
        syncMobileFilterBreadcrumb(document);
        syncNextCategoryLinks(document);
      }, 0);
    });

    applyGridView(currentGridView);
    ensureCategoryDetailsOpen(document);
    syncMobileFilterBreadcrumb();
    syncNextCategoryLinks(document);

    mobileMq.addEventListener('change', () => {
      currentGridView = mobileMq.matches ? '2' : '4';
      if (gridRoot) {
        delete gridRoot.dataset.gridUserSelected;
      }
      applyGridView(currentGridView);
      ensureCategoryDetailsOpen(document);
      syncMobileFilterBreadcrumb();
      syncNextCategoryLinks(document);
    });

    document.querySelectorAll('.collection-filters-545__shell').forEach((shell) => {
      const sectionId = shell.dataset.sectionId;
      const spacer = document.getElementById(`CollectionFiltersSpacer-${sectionId}`);
      if (!spacer) return;

      const syncPosition = () => {
        const measuredHeaderBottom = headerWrapper
          ? headerWrapper.getBoundingClientRect().bottom
          : parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-bottom')) || 0;

        const topOffset = Math.max(0, measuredHeaderBottom);

        shell.style.top = `${topOffset}px`;
        document.documentElement.style.setProperty('--collection-filters-top', `${topOffset}px`);
      };

      const syncSpacer = () => {
        const shellHeight = Math.ceil(shell.getBoundingClientRect().height || shell.offsetHeight || 0);
        spacer.style.height = `${shellHeight}px`;
        document.documentElement.style.setProperty('--collection-filters-height', `${shellHeight}px`);
      };

      const syncAll = () => {
        syncPosition();
        syncSpacer();
      };

      const scheduleSync = rafThrottle(syncAll);
      const resizeObserver = new ResizeObserver(scheduleSync);
      resizeObserver.observe(shell);

      if (headerSection) {
        const headerObserver = new MutationObserver(scheduleSync);
        headerObserver.observe(headerSection, {
          attributes: true,
          attributeFilter: ['class']
        });
      }

      if (headerWrapper) {
        const headerWrapperObserver = new MutationObserver(scheduleSync);
        headerWrapperObserver.observe(headerWrapper, {
          attributes: true,
          attributeFilter: ['class', 'style']
        });
      }

      if (headerWrapper && window.ResizeObserver) {
        const headerResizeObserver = new ResizeObserver(scheduleSync);
        headerResizeObserver.observe(headerWrapper);
      }

      window.addEventListener('scroll', scheduleSync, { passive: true });
      window.addEventListener('resize', scheduleSync);
      window.addEventListener('pageshow', scheduleSync);
      window.addEventListener('load', scheduleSync);

      syncAll();
    });
  });
})();
